import { useLogto } from '@logto/react';
import { Box, Divider, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import { getCurrentUrl } from '../../utils/string';

const Footer: React.FC = () => {
	const { signOut } = useLogto();

	return (
		<Box width={'100%'} flex={1} justifyItems={'center'} paddingTop={1} paddingBottom={2}>
			<Divider flexItem sx={{ width: '60%' }} />
			<Stack width={'40%'} padding={1} textAlign={'center'}>
				<Stack direction={'row'} justifyContent={'center'} spacing={2}>
					<Link
						aria-label="Link to Kibana"
						variant="body2"
						color="text.disabled"
						href={`${import.meta.env.VITE_KIBANA_URL}/spaces/space_selector`}
						target="_blank"
						rel="noreferer"
					>
						Go To Kibana
					</Link>
					<Link component="button" onClick={() => signOut(getCurrentUrl())} color="text.disabled" variant="body2">
						Sign Out
					</Link>
				</Stack>
				<Stack direction={'row'} justifyContent={'center'} spacing={2}>
					<Typography variant="body2" color="text.disabled">
						Prometheus Version {__APP_VERSION__}
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
};

export default Footer;
